import { TripPlace } from '../../lib/types/models/trip-places/trip-places'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderDeparturePlaces(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getDeparturePlaces.url, { id }))
    .get<TripPlace[]>()
}
